<template>
    <v-card class="panelBlock chapter-waivers">
        <v-flex tag="h2" data-qe-id="chapter_waivers_tile">{{waiverTitle}}</v-flex>
        <v-flex class="chapter-waivers__row">
            <v-flex class="chapter-waivers__details" data-qe-id="show_chapter_waivers_link" @click="OpenWaiverLink()">
                {{waiverListLink}}
            </v-flex>
        </v-flex>
    </v-card>
</template>

<script>
    import { communityCommonConstant } from "../../components/ChapterPage/communityCommon.constant";
    import { routerNames } from "../appCommon.constants";

    export default {
        name: 'WaiversTile',
        data: () => ({
            communityCommonConstant,
            routerNames,
        }),
        props: {
            communityType: {
                type: String,
                required: true,
            },
        },
        methods: {
            OpenWaiverLink() {
                const commId = this.$route.params && this.$route.params.communityId ? this.$route.params.communityId : null;
                this.$router.push({
                    path: `/${this.routeType}/${commId}`,
                });
            },
        },
        computed: {
            routeType() {
                return this.isChapterPage ? 'chapterWaiver' : 'regionalWaiver';
            },
            isChapterPage() {
                return this.communityType.toLowerCase() === this.routerNames.CHAPTER.toLowerCase();
            },
            waiverTitle() {
                return this.isChapterPage ? this.communityCommonConstant.chapterAdmin.CHAPTER_WAIVERS : this.communityCommonConstant.REGIONAL_WAIVERS;
            },
            waiverListLink() {
                return this.isChapterPage ? this.communityCommonConstant.chapterAdmin.CHAPTER_WAIVERS_LIST : this.communityCommonConstant.REGIONAL_WAIVER_LIST;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";

    .chapter-waivers {
        &__row {
            position: relative;
            color: $ypo_blue;
            margin: 0;
            align-items: center;
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover {
                background: rgba($ypo-tile-border, 0.3);
                font-weight: 600;
            }
        }

        &__details {
            border-bottom: 1px solid rgba($ypo-tile-border, 0.3);
            margin: 0 15px;
            padding: 15px 0;
            
            i {
                font-size: 20px;
                margin-right: 5px;
            }
        }
    }
</style>
